import React, { useState } from "react";
import { ContentContainer } from "../../components/layout";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const AccountingRefundRequest = () => {
//   const [refundRequest, setRefundRequest] = useState({
//     freshdeskTicketNumber: "",
//     customerName: "",
//     lockerAddress: packageData.lockerLocation,
//     totalAmountPaid: paymentData.paymentAmount,
//     paymentCurrency: paymentData.paymentCurrency,
//     paymentId: paymentData.paymentId,
//     paymentFor: "",
//     paymentChannel: paymentData.paymentCurrency === "PHP" ? -1 : 5, // Use default first
//     proofOfPayment: [],
//     refundMethod: -1,
//     refundType: "full",
//     refundAmount: paymentData.paymentAmount, // Set to full amount initially
//     refundReason: "",
//     customerRefundDetails: {
//       name: "",
//       bankAccountNumber: "",
//     },
//     personnelDetails: {
//       username: localStorage.getItem("user")
//         ? JSON.parse(localStorage.getItem("user")).username
//         : "",
//       email: localStorage.getItem("user")
//         ? JSON.parse(localStorage.getItem("user")).email
//         : "",
//     },
//     requestedOn: formatDateTime(new Date()),
//     approvedBy: -1,
//   });

  return (
    <>
      <ContentContainer containerTitle={`Refund Requests`}>
        <Card>
          <DataTable>
            <Column />
          </DataTable>
        </Card>
      </ContentContainer>
    </>
  );
};

export default AccountingRefundRequest;
